import { Button, ButtonVariants } from '../../../../Atoms/Button';

interface IPrevNextButtonSection {
  handlePrevious: () => void;
  getPreviousTab: () => string | null | undefined;
  handleNext: () => void;
  getNextTab: () => string | null | undefined;
}

export const PrevNextButtonSection = ({
  handlePrevious,
  getPreviousTab,
  handleNext,
  getNextTab,
}: IPrevNextButtonSection) => {
  return (
    <div
      className="sticky bottom-0 right-0 py-3 px-8 bg-white w-full sm:fixed"
      style={{ boxShadow: '0px -4px 10px 0px #0000001F' }}
    >
      <div className="flex items-center justify-end gap-2 sm:justify-between">
        <Button
          variant={ButtonVariants.bluetext}
          className="px-10 sm:w-full"
          onClick={handlePrevious}
          disabled={!getPreviousTab()}
        >
          Previous
        </Button>
        <Button
          variant={ButtonVariants.bluebordered}
          className="px-10 sm:w-full"
          onClick={handleNext}
          disabled={!getNextTab()}
        >
          Next
        </Button>
      </div>
    </div>
  );
};
